import '../rateCard/rateCard.css';
import React, { useState, useEffect, useRef } from "react";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { provideTrainingMaterialClarification, viewdownloadDocument } from './knowledgeMangementApi';
import { knowledgeMultipleWorkFlow } from './knowledgeMangementApi';
import { allowedFileTypes, FILE_NAME_VALIDATION_ERROR, PROD } from '../../..//common/constants';
import { Container, Stack, Box, Typography, Grid, FormControl, FormControlLabel, RadioGroup, Radio, DialogContent, Dialog, DialogActions, Button, TextField, Fab } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { loaderService } from '../../../common/custom-loader/loader-service';
import { authKey, UPLOAD_DCUMENT } from '../../../common/URLs';
import { fileNameValidation } from '../../../common/commonValidations';
import apiClient from "../../../axios";

function VerifyKnowledgeManagement() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const trainingMaterialDetails = state?.workFlowRequestDetails;
    const materialFileDetails = state?.workFlowRequestDetails?.trainingMaterialDtlsLst[0];
    const [approvalArray, setApprovalArray] = useState([])
    const userlog = useRef(true);
    const [knowledgeWorkflow, setKnowledgeWorkflow] = useState();
    const [openDocEdit, setOpenDocEdit] = useState(false);
    const [hideDoc, setHideDoc] = useState(true);
    const [selectedFile, setSelectedFile] = useState();
    const [traningMaterialResponse, setTraningMaterialResponse] = useState();

    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);

    const [logConfirmModalOpen2, setLogConfirmModalOpen2] = useState(false);
    const handleConfirmLogModalOpen2 = () => setLogConfirmModalOpen2(true);
    const handleConfirmLogModalClose2 = () => setLogConfirmModalOpen2(false);

    const [updatedTrainingMaterial, setUpdatedTrainingMaterial] = useState({
        id: state?.workFlowRequestDetails?.trainingMaterialDtlsLst[0].id,
        fileName: state?.workFlowRequestDetails?.trainingMaterialDtlsLst[0].fileName,
        fileContainerName: "resourcefiles",
        fileStorage: state?.workFlowRequestDetails?.trainingMaterialDtlsLst[0].fileStorage,
        stakeholderCategory: state?.workFlowRequestDetails?.trainingMaterialDtlsLst[0].stakeholderCategory,
        requestNumber: state?.workFlowRequestDetails?.trainingMaterialDtlsLst[0].requestNumber,
        applicationNumber: state?.workFlowRequestDetails?.trainingMaterialDtlsLst[0].applicationNumber,
    });

    const [errorMessage, setErrorMessage] = useState({
        commentError: "",
        fileNameError: ""
    });

    useEffect(() => {
        if (userlog.current) {
            userlog.current = false;
            if (state?.workFlowRequestDetails?.trainingMaterialDtlsLst) {
                state?.workFlowRequestDetails?.trainingMaterialDtlsLst.map((item) => {
                    approvalArray.push({ applicationNumber: item.applicationNumber, remarks: '', action: '' });
                    // console.log(approvalArray)
                });
            }
        }
    }, [userlog, state?.workFlowRequestDetails?.trainingMaterialDtlsLst]);

    useEffect(() => {
        if (knowledgeWorkflow) {
            if (knowledgeWorkflow.status === "SUCCESS") {
                toast.success(knowledgeWorkflow?.description);
                navigate('../home');
            }
            else toast.error(knowledgeWorkflow?.description)
        }
    }, [knowledgeWorkflow]);

    useEffect(() => {
        if (traningMaterialResponse) {
            if (traningMaterialResponse.status === "SUCCESS") {
                toast.success(traningMaterialResponse?.description);
                navigate('../home');
            }
            else toast.error(traningMaterialResponse?.description)
        }
    }, [traningMaterialResponse]);

    const radioChange = (e, applicationNumber) => {
        // e.preventDefault();
        const tempArr = (approvalArray?.map(item => {
            if (item?.applicationNumber === applicationNumber) {
                item.action = e.target.value
            }
            return item;
        }
        ))
        setApprovalArray(tempArr);
    }

    const handleChange = (e) => {
        const itemtempArr = (approvalArray?.map(item => {
            item.remarks = e.target.value
            return item;
        }
        ))
        setApprovalArray(itemtempArr);
        setErrorMessage({ ...errorMessage, commentError: "" })
    }

    const onAllClick = (e, actionType) => {
        e.preventDefault();
        const tempApprovalArr = (approvalArray?.map(item => {
            item.action = actionType
            return item;
        }
        ))
        setApprovalArray(tempApprovalArr);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (approvalArray.some(item => item.action === '')) {
            toast.error("Please act on all applications")
        }
        else {
            if (approvalArray.some(item => item.remarks === '')) {
                setErrorMessage({ ...errorMessage, commentError: "Please provide the comment" })
            }
            else {
                handleConfirmLogModalOpen();
            }
        }
    }
    function onConfirmCallBack() {
        if (trainingMaterialDetails?.trainingMaterialDtlsLst?.every(item1 => item1?.workflowRqstDtls?.previousStepAction === "Seek_Clarification")) {
            provideTrainingMaterialClarification(updatedTrainingMaterial, setTraningMaterialResponse);
            knowledgeMultipleWorkFlow(approvalArray, setKnowledgeWorkflow);
        }
        else knowledgeMultipleWorkFlow(approvalArray, setKnowledgeWorkflow);
    }

    function onCancelBack() {
        handleConfirmLogModalClose();
    }

    const onEditDocClick = () => {
        handleConfirmLogModalOpen2();
    }

    function onCancelBack2() {
        handleConfirmLogModalClose2();
    }

    const onConfirmDocEdit = () => {
        handleConfirmLogModalClose2();
        setOpenDocEdit(true);
        setHideDoc(false);
    }

    useEffect(() => {
        if (selectedFile) {
            getUploadDocumentDetails();
        }
    }, [selectedFile]);

    const uploadDocument = (e, type) => {
        if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setErrorMessage({
                ...errorMessage,
                fileNameError: "The file should be less than 5MB",
            });
        }
        else if (e.target.files[0].name.split('.')?.length > 2) {
            setErrorMessage({
                ...errorMessage,
                fileNameError: "Double extension file detected",
            });
            setSelectedFile();
        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setErrorMessage({
                ...errorMessage,
                fileNameError: FILE_NAME_VALIDATION_ERROR,
            });
            setSelectedFile();
        }
        else {
            setSelectedFile(e.target.files[0]);
            setErrorMessage({ ...errorMessage, fileNameError: " " });
        }
    };

    function getUploadDocumentDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "resourcefiles");
        apiClient
            .post(UPLOAD_DCUMENT, formData, {
                headers: {
                    AuthKey: authKey,
                },
            })
            .then((response) => {
                setUpdatedTrainingMaterial({ ...updatedTrainingMaterial, fileStorage: response.data.blobResponse.blobFileName, fileName: response.data.blobResponse.fileName })
                loaderService.hideLoader();
            })

            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    const commentColumns = [
        { field: 'previousStepUser', headerName: "User", width: 300 },
        { field: 'previousStepComments', headerName: "Comment", width: 650 },
    ]

    const columns = [
        { field: 'applicationNumber', headerName: "Application Number", width: 200 },
        { field: 'stakeholderCategory', headerName: "Stakeholder Name", width: 200 },
        { field: 'fileName', headerName: "File Name", width: 200 },
        {
            field: 'actions', headerName: 'Actions', width: 400, hide: state?.type !== "all",
            renderCell: (params) => {
                return (
                    <>
                        {(state?.type !== "sent" && state?.type !== "actionTaken") &&
                            (params.row?.workflowRqstDtls?.previousStepAction === "Seek_Clarification") ?
                            <>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        name="radio-buttons-group1"
                                    >
                                        <FormControlLabel name={"action" + params.row?.applicationNumber} value="Knowledge_Clarification" checked={approvalArray.find((approvalItem) => approvalItem?.applicationNumber === params.row?.applicationNumber)?.action === "Knowledge_Clarification"} onChange={(e) => radioChange(e, params.row?.applicationNumber)} control={<Radio size="small" />} label="Provide Clarification" />
                                    </RadioGroup>
                                </FormControl>
                            </>
                            :
                            <>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        name="radio-buttons-group2"
                                    >
                                        <FormControlLabel name={"action" + params.row?.applicationNumber} value="Approved" checked={approvalArray.find((approvalItem) => approvalItem?.applicationNumber === params.row?.applicationNumber)?.action === "Approved"} onChange={(e) => radioChange(e, params.row?.applicationNumber)} control={<Radio size="small" />} label="Approve" />
                                        <FormControlLabel name={"action" + params.row?.applicationNumber} value="Rejected" checked={approvalArray.find((approvalItem) => approvalItem?.applicationNumber === params.row?.applicationNumber)?.action === "Rejected"} onChange={(e) => radioChange(e, params.row?.applicationNumber)} control={<Radio size="small" />} label="Reject" />
                                        <FormControlLabel name={"action" + params.row?.applicationNumber} value="Seek_Clarification" checked={approvalArray.find((approvalItem) => approvalItem?.applicationNumber === params.row?.applicationNumber)?.action === "Seek_Clarification"} onChange={(e) => radioChange(e, params.row?.applicationNumber)} control={<Radio size="small" />} label="Seek for clarification" />
                                    </RadioGroup>
                                </FormControl>
                            </>
                        }
                    </>
                )
            }
        }
    ]

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p className='pageNumberingResc'>RES14</p>}
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h5" gutterBottom>
                        <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                            <KeyboardArrowLeftRounded />
                        </Fab> Verify Training Material
                    </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h6" gutterBottom>
                        Assignment-Operation: {trainingMaterialDetails?.trainingMaterialDtlsLst?.[0]?.workflowRqstDtls?.operation}
                    </Typography>
                </Stack>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <DataGrid autoHeight
                            rows={trainingMaterialDetails.trainingMaterialDtlsLst}
                            columns={columns}
                            pageSize={10}
                            getRowId={(row) => row?.applicationNumber}
                        />
                    </Grid>
                    <Grid item xs={12} mt={2}>
                        <Typography variant="h6">
                            {t('reg.commentHistory')}
                        </Typography>
                        <DataGrid autoHeight
                            rows={trainingMaterialDetails?.trainingMaterialDtlsLst[0]?.workflowRqstDtls?.workflowCommentHistory ? trainingMaterialDetails?.trainingMaterialDtlsLst[0]?.workflowRqstDtls?.workflowCommentHistory.map((commentItem) => ({ ...commentItem, id: uuidv4() })) : []}
                            columns={commentColumns}
                            pageSize={10}
                        />
                    </Grid>
                    {(state?.type !== "sent" && state?.type !== "actionTaken") && <Grid item xs={12} lg={8} sx={{ mt: 2 }}>
                        <TextField fullWidth
                            error={errorMessage.commentError}
                            helperText={errorMessage.commentError}
                            id="outlined-multiline-static"
                            label={t('reg.comment')}
                            multiline
                            rows={4}
                            name="remarks" value={approvalArray?.remarks} onChange={(e) => handleChange(e)}
                        />
                    </Grid>}
                    {
                        hideDoc &&
                        <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                            <div className='labels-plantation'>Uploaded Document</div>
                            <div className="Rescview-file-link-common" style={{ display: "flex", flexDirection: "row" }}>
                                <Typography onClick={(e) => viewdownloadDocument(materialFileDetails?.fileStorage, materialFileDetails?.fileName, "View")} >
                                    {materialFileDetails?.fileName}
                                </Typography> <EditIcon sx={{ ml: 1 }} onClick={(e) => onEditDocClick(e)} hidden={trainingMaterialDetails?.trainingMaterialDtlsLst?.every(item1 => item1?.workflowRqstDtls?.previousStepAction !== "Seek_Clarification")} />
                            </div>
                        </Grid>
                    }
                    {
                        openDocEdit &&
                        <Grid item xs={12} lg={12} mb={2}>
                            <div className="labels-plantation-upload">{t('resource.uploadDocument')}<span className='mandatory_field'>*</span></div>
                            <div className="geocode-photo-choosefile">
                                <label className="chooseFile-create-plantation">
                                    <input
                                        style={{ display: "none" }}
                                        type="file"
                                        accept="image/jpeg, image/png, .txt, .doc, .pdf, .csv, .ppt, .mp4"
                                        name="photo"
                                        onChange={(e) => uploadDocument(e)}
                                    ></input>
                                    {t('resource.chooseFile')}
                                </label>
                                <label className="photoName-create-plantation" style={{ marginRight: "2vh" }}>
                                    {updatedTrainingMaterial?.fileName}
                                </label>
                                <div className="resource-common-error-message">
                                    {errorMessage.fileNameError}
                                </div>
                            </div>
                            <span style={{ marginLeft: "0vh" }} className="file_info">{t('preReg.uploadFileTypeNote')}</span>
                        </Grid>

                    }

                </Grid>
                {(state?.type !== "sent" && state?.type !== "actionTaken") && <Grid xs={12} md={12} spacing={1} display='flex' justifyContent="flex-end">
                    {trainingMaterialDetails?.trainingMaterialDtlsLst?.some(item1 => item1?.workflowRqstDtls?.previousStepAction !== "Seek_Clarification") && <><Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick(e, "Seek_Clarification")}>Seek clarification for All</Button>
                        <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick(e, "Rejected")}>Reject All</Button>
                        <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick(e, "Approved")}>Approve All</Button>
                    </>}
                    {trainingMaterialDetails?.trainingMaterialDtlsLst?.every(item1 => item1?.workflowRqstDtls?.previousStepAction === "Seek_Clarification") &&
                        <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick(e, "Knowledge_Clarification")}>Provide Clarification for All</Button>

                    }
                    <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='submit' onClick={(e) => onSubmit(e)}>Submit</Button>

                </Grid>}
            </Container>
            <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} action="Submit" />
            <ConfirmationPopover onOpen={logConfirmModalOpen2} onConfirm={onConfirmDocEdit} onClose={onCancelBack2} action="Edit Document" />
        </>
    );
}
export default VerifyKnowledgeManagement;
